<template src="./unauthorized.pug" lang="pug"></template>

<script>
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'Unauthorized',

  components: {
    ButtonPrimary
  },

  data () {
    return {
      imageNotFound: require('../../../assets/notFound/forbidden.png')
    }
  },

  computed: {
    client () {
      return this.$store.getters.client
    }
  },

  methods: {
    goHome () {
      location.href = this.client ? PATHS.HOME : PATHS.LOGIN
    }
  }
}
</script>

<style>
.vertical-center {
  /* Make it a flex container */
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  /* Align the bootstrap's container vertically */
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  width: 100%;

  -webkit-box-pack: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}

.bg-tela-login:after {
  content: "";
  position: fixed;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  left: 0;
  right: 0;
  height: 8px;
}

.bg-tela-login:after {
  bottom: 0;
}

.bg-tela-login {
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #223768;
  background: #223768;
  background: -webkit-linear-gradient(left, #1C3B65, #40B9BB);
  background: -o-linear-gradient(right, #223768, #00C3BE);
  background: -moz-linear-gradient(right, #223768, #00C3BE);
  background: linear-gradient(to right, #223768, #00C3BE);
  height: auto !important;
  min-height: 100vh;
}

.middle-white-box {
  height: 485px;
  width: 774px;
  background-color: #FFF;
  display: table;
  text-align: center;
}

.not-found-img {
  width: 245px;
  height: 287px;
}

.image-container {
  display: table-cell;
}

.image-container img {
  display: block;
  margin: 1.5vh auto;
}

p.big-txt {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: #646464;
  font-size: 21px;
  margin: 1.5vh auto;
}

p.md-txt {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: #646464;
  font-size: 16px;
  margin: 0.5vh auto;
}
</style>



// WEBPACK FOOTER //
// Unauthorized.vue?7191b862